import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

import { useBreakPoint } from '../../../hooks/useBreakPoint';
import useCreateLessonState, {
  DynamicLessonState,
  DynamicLessonStateProvider,
} from '../../../hooks/useCreateLessonState';
import { useLocale } from '../../../hooks/useLocale';
import useSignIn from '../../../hooks/useSignIn';
import HotjarSnippet from '../../analytics/HotJar';
import ObjectiveRefinement from './intent-refinement/ObjectiveRefinement';

export const SubPageLayout = ({
  children,
  pageTitle,
  subTitle,
}: {
  children: JSX.Element | JSX.Element[];
  pageTitle?: string;
  subTitle?: string;
}) => {
  const isDesktop = useBreakPoint(700);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100%',
        paddingBottom: isDesktop ? 0 : 80,
      }}
    >
      <div style={{ marginBottom: isDesktop ? 0 : 0 }}>
        {pageTitle && (
          <h1
            style={{
              width: '100%',
              textAlign: 'center',
              fontWeight: 800,
              fontSize: isDesktop ? 36 : 22,
              padding: '0 10px',
              marginBottom: 0,
            }}
          >
            {pageTitle}
          </h1>
        )}

        {subTitle && <h2 style={{ textAlign: 'center' }}>{subTitle}</h2>}
      </div>

      {children}
    </div>
  );
};

export type SavedRecentPrompt = {
  dynamicLessonState: DynamicLessonState;
  createdAt: string;
  id: string;
};

const OldObjectiveRefinement = () => {
  const { dynamicLessonState, dispatchAndSync } = useCreateLessonState();
  return (
    <DynamicLessonStateProvider value={{ dynamicLessonState, dispatchAndSync }}>
      <ObjectiveRefinement />
    </DynamicLessonStateProvider>
  );
};

const CreatePage = () => {
  useLocale();
  const { signIn } = useSignIn();

  const session = useSession();

  useEffect(() => {
    if (session.status === 'unauthenticated') {
      signIn({ callbackUrl: window.location.href });
    }
  }, [session, signIn]);

  if (session.status === 'unauthenticated') {
    return null;
  }

  return (
    <>
      <OldObjectiveRefinement />
      <HotjarSnippet />
    </>
  );
};

export default CreatePage;
